import type { DashboardNotification } from "@/v2Projects/types";

const EVENT_ICON_MAP: Record<string, { bg: string; fg: string; path: string }> = {
  project_quote_paid: {
    bg: "bg-emerald-50",
    fg: "text-emerald-600",
    path: "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z",
  },
  project_quote_updated: {
    bg: "bg-amber-50",
    fg: "text-amber-600",
    path: "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z",
  },
  project_assigned_to_expert: {
    bg: "bg-emerald-50",
    fg: "text-emerald-600",
    path: "M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z",
  },
  project_assigned: {
    bg: "bg-emerald-50",
    fg: "text-emerald-600",
    path: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
  },
  project_assignment_digest: {
    bg: "bg-blue-50",
    fg: "text-blue-600",
    path: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
  },
  project_note_added: {
    bg: "bg-violet-50",
    fg: "text-violet-600",
    path: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z",
  },
  chat_group_note_added: {
    bg: "bg-violet-50",
    fg: "text-violet-600",
    path: "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z",
  },
};

const DEFAULT_EVENT_ICON = {
  bg: "bg-gray-100",
  fg: "text-gray-500",
  path: "M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0",
};

export function getNotificationEventIconStyle(eventType: DashboardNotification["event_type"]) {
  return EVENT_ICON_MAP[eventType] ?? DEFAULT_EVENT_ICON;
}

function metadataString(notification: DashboardNotification, key: string): string | undefined {
  const value = notification.metadata?.[key];
  return typeof value === "string" ? value : undefined;
}

export function getNotificationDisplayBody(notification: DashboardNotification): string {
  if (notification.event_type !== "project_quote_paid") {
    return notification.body;
  }

  const actorName =
    metadataString(notification, "actor_display_name") ??
    metadataString(notification, "payment_actor_display_name");

  if (!actorName) {
    return notification.body;
  }

  if (notification.body.includes(actorName)) {
    return notification.body;
  }

  const recipientGroup = metadataString(notification, "recipient_group");
  const isExpertNotification =
    recipientGroup === "expert" || notification.deep_link.startsWith("/expert/projects/");

  return isExpertNotification
    ? `${actorName} paid for your proposal.`
    : `${actorName} completed payment. The project can now begin.`;
}

export function getNotificationDeepLink(notification: DashboardNotification): string {
  const shouldOpenProposal =
    (notification.event_type === "project_quote_updated" ||
      notification.event_type === "project_quote_paid") &&
    !!notification.message_id;

  if (!shouldOpenProposal) {
    return notification.deep_link;
  }

  const [path, rawQuery = ""] = notification.deep_link.split("?");
  const params = new URLSearchParams(rawQuery);
  params.set("messageId", notification.message_id!);
  params.set("openProposal", "1");

  return `${path}?${params.toString()}`;
}
